import React, { Fragment, useContext, useEffect } from "react";
import { BackgroundDiv } from "../../Nftf/Receipt/ReceiptStyle";
import ArrowLeft from "../../../resources/images/nftf/arrow-left.svg";
import BottomBtn from "../Bottom/BottomBtn";
import { _O } from "../../../modules/utils";
import WhiteLeftArrowHeader from "../Header/WhiteLeftArrowHeader";
import {
  Body,
  BoldText,
  CardName,
  CardNoti,
  CardText,
  ContentsBody,
  ContentsTitle,
  ReceiptBoldText,
  ReceiptDiv,
  ReceiptText,
  ReceiptTitle,
  SeparateLine,
  StyledDiv,
  Text,
  TextData,
  TextDiv,
  TextTitle,
} from "./PayStyle";
import a from "../../../resources/images/nftf/exclamation-circle.svg";
import { AppContext } from "../../../components/AppProvider";
import { Base64, decode } from "js-base64";
import { NativeAction } from "../../../modules/utils/HandleWs";

const PayHistory = props => {
  const { userinfo, phonecfg } = useContext(AppContext);
  const data = JSON.parse(Base64.decode(decode(props.match.params.data)));

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#FFFFFF");
  }, []);
  return (
    <BackgroundDiv style={{ flexFlow: "column", height: "100vh" }}>
      <WhiteLeftArrowHeader title="비대면진료 결제" moveUrl="/resrvList" />
      <Body>
        <ContentsBody>
          <ContentsTitle>
            {/* <BoldText>{userinfo.userName}님 진료 결제내역</BoldText> */}
            <BoldText>
              {data.rqstRelCd === "FAMZ" ? data.famzNm : userinfo.userName}님
              진료 결제내역
            </BoldText>
            <Text>케어포미 비대면진료를 이용해 주셔서 감사합니다</Text>
          </ContentsTitle>

          <div style={{ width: "calc(100% - 14px)", paddingBottom: "78px" }}>
            <StyledDiv />
            <ReceiptDiv>
              <ReceiptTitle>
                <ReceiptBoldText>
                  {data.hospital[0].hpName +
                    "(" +
                    data.hospital[0].address2 +
                    ")"}
                </ReceiptBoldText>
                {/* <ReceiptText>비대면진료 영수증</ReceiptText> */}
              </ReceiptTitle>

              <SeparateLine />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexFlow: "column",
                  gap: "4px",
                }}>
                <TextDiv>
                  <TextTitle>담당의사</TextTitle>
                  <TextData>{data.appDR}</TextData>
                </TextDiv>
                <TextDiv>
                  <TextTitle>진료일시</TextTitle>
                  <TextData>{data.appDelayTime}</TextData>
                </TextDiv>

                {data.payDh && (
                  <TextDiv>
                    <TextTitle>결제일시</TextTitle>
                    <TextData>{data.payDh}</TextData>
                  </TextDiv>
                )}
              </div>
              <SeparateLine />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexFlow: "column",
                  gap: "4px",
                }}>
                <TextDiv>
                  <TextTitle>병원 진료비</TextTitle>
                  <TextData>
                    {parseInt(data.amount).toLocaleString("ko-KR", 0)}원
                  </TextData>
                </TextDiv>
                {/* {data.payStatus == 1 && data.payCmpltYn === "N" && data.cmsnAmt != "0" && (
                  <TextDiv>
                    <TextTitle>수수료</TextTitle>
                    <TextData>{parseInt(data.cmsnAmt).toLocaleString("ko-KR", 0)}원</TextData>
                  </TextDiv>
                )} */}
              </div>

              <SeparateLine />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexFlow: "column",
                  gap: "4px",
                }}>
                <TextDiv>
                  <TextTitle>비대면진료 서비스 이용료</TextTitle>
                  <TextData>
                    {parseInt(data.cmsnAmt).toLocaleString("ko-KR", 0)}원
                  </TextData>
                </TextDiv>
                {data.cpnAmt && (
                  <Fragment>
                    <TextDiv>
                      <TextTitle>할인쿠폰 사용</TextTitle>
                      <TextData style={{ color: "#6b65de" }}>
                        - {parseInt(data.cpnAmt).toLocaleString("ko-KR", 0)}원
                      </TextData>
                    </TextDiv>
                    <TextDiv style={{ paddingLeft: "8px" }}>
                      <div style={{ display: "flex", gap: "4px" }}>
                        <TextTitle style={{ color: "#6b65de" }}>•</TextTitle>
                        <TextTitle style={{ color: "#6b65de" }}>
                          {/* 비대면진료 서비스 이용료 <br /> 100% 할인 쿠폰 */}
                          {data.cpnNm}
                        </TextTitle>
                      </div>
                    </TextDiv>
                  </Fragment>
                )}
              </div>
              <SeparateLine />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexFlow: "column",
                  gap: "4px",
                }}>
                <TextDiv>
                  <TextTitle>최종 결제금액</TextTitle>
                  <TextData style={{ fontWeight: "600", fontSize: "16px" }}>
                    {parseInt(data.totAmt).toLocaleString("ko-KR", 0) + "원"}
                  </TextData>
                  {/* <TextData style={{ fontWeight: "600", fontSize: "16px" }}>
                    {data.payStatus == 1 &&
                    data.payCmpltYn === "N" &&
                    data.cmsnAmt != "0"
                      ? (
                          parseInt(data.amount) + parseInt(data.cmsnAmt)
                        ).toLocaleString("ko-KR", 0) + "원"
                      : parseInt(data.amount).toLocaleString("ko-KR", 0) + "원"}
                  </TextData> */}
                </TextDiv>
              </div>

              <div style={{ display: "flex" }}>
                <CardNoti>
                  <img src={a} />
                </CardNoti>
                <CardName>{data.cardNm}</CardName>
                <CardText>로 자동결제 되었습니다</CardText>
              </div>
            </ReceiptDiv>
          </div>
        </ContentsBody>
      </Body>

      <BottomBtn text="확인" event={() => _O.Open("/resrvList")} />
    </BackgroundDiv>
  );
};

export default PayHistory;
